import { render, staticRenderFns } from "./TheCShopContentFirstNoShop.vue?vue&type=template&id=42f59d05&scoped=true&"
import script from "./TheCShopContentFirstNoShop.vue?vue&type=script&lang=js&"
export * from "./TheCShopContentFirstNoShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f59d05",
  null
  
)

/* custom blocks */
import block0 from "./TheCShopContentFirstNoShop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
